import PropTypes from 'prop-types';

import { Abstrap } from '../../..';

const propTypes = {
    ...Abstrap.propTypes,
    disabled: PropTypes.bool,
    expanded: PropTypes.bool,
    type: PropTypes.oneOf([
        'radio',
        'checkbox',
        'completion',
        'password',
        'select',
        'textarea',
        'toggle',
        'fileupload',
        'colorpicker',
    ]),
};

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'div',
    disabled: false,
    expanded: false,
};

class FormField extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            disabled,
            expanded,
            type,
        } = this.props;
        return [
            'c-form__field',
            type ? `c-form__field_${type}` : false,
            expanded ? `c-form__field_${type}_expanded` : false,
            disabled ? `c-form__field_${type}_disabled` : false,
            className,
        ];
    }

}

FormField.propTypes = propTypes;

FormField.defaultProps = defaultProps;

export default FormField;
